<template>
  <div class="exerciseList">

    <div class="container">
      <div class="tabY cf">
        <div class="search">
          <Form ref="formItem" inline :model="formItem" :label-width="108">
            <div class="searchDiv">
              <FormItem style="width:300px;" label="运动会名称：" prop="gameNameCHN">
                <Input placeholder="请输入运动会名称" v-model="formItem.gameNameCHN"></Input>
              </FormItem>
              <FormItem style="width:260px;" label="运动会开始时间：" prop="beginTime">
                <DatePicker type="date" @on-change="searchStartTime" v-model="formItem.beginTime" format="yyyy-MM-dd" placeholder="运动会开始时间">
                </DatePicker>
              </FormItem>
              <FormItem style="width:260px;" label="运动会结束时间：" prop="endTime">
                <DatePicker type="date" @on-change="searchEndTime" v-model="formItem.endTime" format="yyyy-MM-dd" placeholder="运动会结束时间"></DatePicker>
              </FormItem>
              <Button type="info" @click="searchSubmit" icon="ios-search">搜索</Button>
            </div>
          </Form>
        </div>
      </div>

      <!-- <div class="exercisTables"> -->
      <div>
        <Table stripe border :columns="tableHead" :data="tableList" class="tableCss"></Table>
      </div>
      <Page :total="total_record" :page-size="pag.page_size" class="sportermeetingPage" :current="pag.page_no" @on-change="changepage" show-elevator
        show-total placement="top" />
    </div>
  </div>
</template>

<script>
import { getSportList, currentTimes, createAward } from "@/lib/api/";

export default {
  computed: {
    historicalRole() {
      console.log(
        JSON.parse(localStorage.authorities),
        this.$PlugIn.role.admin
      );
      return JSON.parse(localStorage.authorities) == this.$PlugIn.role.admin;
    },
  },
  data() {
    return {
      stampTiem: "",
      formItem: {
        //分页
        gameNameCHN: "",
        page_no: 1,
        beginTime: "",
        award: true,
        endTime: "",
        page_size: 10,
        sourceType: 0,
        orderByTime: 1,
      },
      total_record: 0,
      pag: {
        //分页
        gameNameCHN: "",
        page_no: 1,
        beginTime: "",
        endTime: "",
        award: true,
        page_size: 10,
        sourceType: 0,
        orderByTime: 1,
      },
      currentTime: "",
      currentTimeM: [],
      Month: "",
      getTime: "",
      YearLength: 4,
      defaultYear: 1,
      loading: true,
      FullYear: "",
      tableHead: [
        {
          title: "运动会名称",
          key: "gameNameCHN",
          width: "260",
        },
        {
          title: "地点",
          key: "gameSiteCHN",
          width: "160",
        },
        {
          title: "比赛开始时间",
          key: "beginTime",
          width: "160",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("p", this.$PlugIn.formatDateTime(params.row.beginTime)),
            ]);
          },
        },
        {
          title: "比赛结束时间",
          key: "beginTime",
          width: "160",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("p", this.$PlugIn.formatDateTime(params.row.endTime)),
            ]);
          },
        },
        {
          title: "操作",
          key: "baoming",
          width: "210",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    // display: this.isPrint(
                    //   params.row.beginTime,
                    //   params.row.endTime
                    // ),
                    marginRight: "6px",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/printCertificate",
                        query: {
                          gameID: params.row.gameID,
                          title: encodeURI(params.row.gameNameCHN),
                        },
                      });
                    },
                  },
                },
                "获奖证书列表"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    display: !this.historicalRole
                      ? "none"
                      : this.isPrint(params.row.beginTime, params.row.endTime),
                  },
                  on: {
                    click: () => {
                      if (this.historicalRole) {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "是否要重新生成奖状吗？",
                          onOk: () => {
                            this.loadings("正在生成中，请稍后...");
                            createAward({ gameId: params.row.gameID })
                              .then((res) => {
                                if (res.data.code === 0) {
                                  this.$Message.info("生成成功");
                                } else {
                                  this.$Message.warning(
                                    "网络请求已经超时，请重新刷新页面"
                                  );
                                }
                                this.loading = false;
                                this.$Spin.hide();
                              })
                              .catch((error) => {
                                this.loading = false;
                                this.$Spin.hide();
                              });
                          },
                        });
                      } else {
                        this.$Message.warning("你没有权限操作，请联系管理员");
                      }
                    },
                  },
                },
                "重新生成奖状"
              ),
            ]);
          },
        },
      ],
      tableList: [],
    };
  },
  components: {},
  methods: {
    //分页方法
    changepage(value) {
      this.pag.page_no = value;
      this.getSportLists(this.pag);
    },
    isPrint(beginTime, endTime) {
      let endT = 1000 * 3600 * 24 + endTime;
      let beginT = 1000 * 3600 * 24 + beginTime;
      let timestamp = this.stampTiem;
      let end = timestamp - 1000 * 3600 * 24 * 183;
      let begin = timestamp - 1000 * 3600 * 24 * 183;
      let state = "none";
      if (localStorage.unitType == "0") {
        state = timestamp < beginTime ? "none" : "inline-block";
      } else {
        state = timestamp < endT || endTime < end ? "none" : "inline-block";
      }
      return state;
    },
    //去左右空格;
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },
    searchStartTime(e) {
      if (e) {
        this.formItem.beginTime = new Date(Date.parse(e));
      }
    },
    searchEndTime(e) {
      if (e) {
        this.formItem.endTime = new Date(Date.parse(e));
      }
    },
    timeFliter() {
      const endTime = new Date().getTime();
      const beginTime = endTime - 1000 * 3600 * 24 * 180;
      this.pag.beginTime = this.formItem.beginTime = new Date(
        Date.parse(this.$PlugIn.formatDateTime(beginTime))
      );
      this.pag.endTime = this.formItem.endTime = new Date(
        Date.parse(this.$PlugIn.formatDateTime(endTime))
      );
      this.getSportLists(this.pag);
    },
    //   搜索
    searchSubmit() {
      this.formItem.page_size = this.pag.page_size;
      this.pag.page_no = 1;
      this.formItem.page_no = 1;
      this.formItem.gameNameCHN = this.trim(this.formItem.gameNameCHN);
      this.pag = this.formItem;

      this.getSportLists(this.formItem);
    },
    getSportLists(pag) {
      getSportList(pag)
        .then((res) => {
          if (res.data.code === 0) {
            this.tableList = res.data.data.results;
            this.total_record = res.data.data.total_record;
          } else {
            this.$Message.warning("网络请求已经超时，请重新刷新页面");
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
  created() {
    currentTimes()
      .then((res) => {
        if (res.data.code === 0) {
          this.stampTiem = parseInt(res.data.data);
          this.timeFliter(this.stampTiem);
        } else {
          this.$Message.warning("网络请求已经超时，请重新刷新页面");
        }
      })
      .catch((error) => {});
  },
  updated() {
    this.$nextTick(function () {
      let position = this.$store.state.grade.position; //返回页面取出来
      window.scroll(0, position);
    });
  },
  beforeRouteLeave(to, from, next) {
    let position =
      document.documentElement.scrollTop || document.body.scrollTop;
    this.$store.commit("SAVE_POSITION", position); // 离开路由时把位置存起来
    next();
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/.tableCss table{
  width: 100% !important;
}
.sportermeetingPage {
  margin-top: 12px;
}
.container {
  min-height: 62vh;
}
.container h3.ti {
  font-size: 18px;
  color: #333;
  padding: 22px 12px;
  background: #deecfe;
  font-weight: normal;
}
.tabY li {
  height: 32px;
  padding: 0 22px;
  color: #666;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  background: #ccc;
  line-height: 32px;
  margin-right: 6px;
}
.tabY li.on,
.tabY li:hover {
  background: #2db7f5;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/list.vue